<template>
  <div class="family-page">
    <div class="page-head">
      <div class="left">
        <h1>Manage family accounts</h1>
      </div>
    </div>
    <FamilyList @update="handleUpdate" ref="FamilyList"></FamilyList>
    <FamilyForm ref="FamilyForm" />
  </div>
</template>

<script>
import FamilyList from "@/components/Family/FamilyList";
import FamilyForm from "@/components/Family/FamilyForm";

export default {
  name: "FamilyAccounts",
  components: {
    FamilyList,
    FamilyForm
  },

  methods: {
    handleUpdate(data) {
      this.$refs.FamilyForm.triggerUpdateModal(data);
    }
  },
  mounted() {}
};
</script>
